<template lang="pug">
  b-container.h-100.d-flex.flex-column
    b-form-row.align-items-center.mt-3.mb-4
      b-col.mb-2.mb-md-0
        h4.mb-0 Objetivos
        //p.mb-0.text-secondary Descripción aquí
      b-col(cols="auto")
        b-button.mr-2(variant="primary", @click="createObjective", :disabled="loading || busy") Crear objetivo
        b-dropdown#parent_drop(right, variant="light", no-caret, :menu-class="['filters-dropdown']")
          template(v-slot:button-content)
            filter-icon.icon-sm
          b-dropdown-form
            b-form-checkbox(v-model="enabled_only", @change="getObjectives") Mostrar sólo los objetivos activos
    .text-center
      b-spinner(v-if="busy", variant="primary")
      empty-message(v-else-if="!objectives.length && !busy", message="No hay objetivos creados")
    b-nav.overflow-x.flex-nowrap.no-wrap.mb-3.scrollable-area#objectives-row(tabs)
      b-nav-item.mb-3(v-for="objective in objectives", :key="objective._id", :to="{name: 'Objective', params: { objective_id: objective._id } }") {{objective.name}}
    router-view(:key="$route.path")
    //SideModal(v-model="objective_side_modal", size="lg", @input="$router.push({name: 'Objectives'}).catch(() => {})")
      router-view
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
const objectivesController = createNamespacedHelpers('objective')
export default {
  data () {
    return {
      loading: false,
      busy: false,
      enabled_only: false,
      objective_side_modal: false,
    }
  },
  computed: {
    ...objectivesController.mapState({
      objectives: state => state.objectives
    })
  },
  methods: {
    ...mapActions(['objective/all', 'objective/create']),
    getObjectives () {
      let self = this
      this.busy = true

      let params = {
        //...self.paginationParamsObject
      }

      if(this.enabled_only) {
        params.enabled = this.enabled_only
      }

      this['objective/all']({
        account_id: self.$route.params.account_id,
        params: params,
        callback: res => {
          self.busy = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            //self.parsePaginationDataFromResponse(res)
            if(self.objectives.length && !self.$route.params.objective_id) {
              self.$router.push({name: 'Objective', params: { objective_id: self.objectives[0]._id } }).catch(() => {})
            }
          }
        }
      })
    },
    createObjective () {
      let self = this
      this.loading = true
      let params = {
        account_id: self.$route.params.account_id,
        name: "Nuevo objetivo"
      }

      this['objective/create']({
        ...params,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$router.push({name: "Objective", params: {objective_id: res.resource._id}}).catch(() => {})
          }
        }
      })
    },
  },
  mounted () {
    this.getObjectives()
  },
  /*watch: {
    '$breakpoint' (value) {
      if (value.lgUp) {
        this.objective_side_modal = false
      }

      if (value.mdDown && this.$route.name === 'Objective' && this.$route.params.objective_id) {
        this.objective_side_modal = true
      }
    },
    '$route' (value) {
      this.objective_side_modal = value.name === 'Objective' && value.params.objective_id && this.$breakpoint.mdDown;
    },
  }*/
}
</script>

<style lang="scss" scoped>
#objectives-row {
  min-height: 50px;
}
</style>
